import React, { Component } from "react";

class NotFound extends Component {
  render() {
    return (
      <main className="sitemap">
        <section className="section">
          <div className="container">
            <h1 className="trade b text-uppercase">Sitemap</h1>
            <a href="/" className="fz-lg b d-block black">
              Homepage
            </a>
            <a href="/resources" className="fz-lg b d-block black">
              MIM Setup Instructions
            </a>
            <a href="/about" className="fz-lg b d-block black">About Amyvid</a>
            <a href="/register" className="fz-lg b d-block black">Register</a>
            <a href="/module-1/overview" className="fz-lg b d-block black">
              Module 1 Overview
            </a>
            <a href="/module-2/overview" className="fz-lg b d-block black">
              Module 2 Overview
            </a>
            <a href="/module-3/overview" className="fz-lg b d-block black">
              Module 3 Overview
            </a>
            <a href="/module-4/overview" className="fz-lg b d-block black">
              Additional Scans for Review (optional)
            </a>
            <a href="/module-5/overview" className="fz-lg b d-block black">
              Reporting Module (optional)
            </a>
          </div>
        </section>
      </main>
    );
  }
}

export default NotFound;
